import Navigation from "./Navigation";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(Navigation);
